import React from 'react';

const PlatformExperienceIcon = (props) => (
  <svg role='presentation' width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor'>
      <path d='M16 6c1.657 0 3 1.343 3 3 0 .842-.347 1.603-.906 2.148l3.629 7.865c.091-.009.184-.013.277-.013 1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3c0-.843.347-1.604.907-2.15l-3.629-7.863c-.092.009-.184.013-.278.013-.093 0-.186-.004-.277-.013l-3.63 7.864c.56.545.907 1.306.907 2.149 0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3c.093 0 .186.004.277.013l3.63-7.864C13.347 10.604 13 9.843 13 9c0-1.657 1.343-3 3-3z' />
    </g>
  </svg>
);

export default PlatformExperienceIcon;
